import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from 'src/app/shared/adapters/datepicker-adapter';
import { EmployeeService } from '../shared/services/employee.service';
import { employee } from '../shared/models/employee.model';
import { EmployeeModel } from '../shared/models/employeeModel';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-add-employee',
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class AddEmployeeComponent implements OnInit {

  @Input() public updateEmployeeData;
  viewModel: EmployeeModel;
  //getEmployeeData:any;
  //updateEmployeeData:any;
  InsertDate: NgbDateStruct;
  @ViewChild("employeeForm") employeeForm: NgForm;
  constructor(private _employeeSvc: EmployeeService, public activeModal: NgbActiveModal, private _toasterSvc : ToastrService) { }

  ngOnInit() {
    this.resetForm();
    if(this.updateEmployeeData){
      this.viewModel = this.updateEmployeeData.Employee;
      this.viewModel.ConfirmPassword = this.viewModel.Password;
    }

    

  }

  resetForm() {
    let date = new Date();
    this.InsertDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() },

      this.viewModel = {
        CreatedBy: null,
        CreatedById: 2005,
        HasErrors: false,
        ID: 0,
        InsertDate: (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear(),
        IsActive: true,
        LastUpdatedBy: null,
        LastUpdatedById: 0,
        ModifiedDate: null,
        ResultMessages: [],

        AccessLevel: null,
        CreatedUserId: null,
        DeviceId: null,
        DrivingLisence: null,
        Email: '',
        FingerPrint: null,
        FirstName: '',
        FranchiesId: null,
        FullName: '',
        IsCorporate: 0,
        IsCurrentEmployee: null,
        IsWebAccess: null,
        LastName: '',
        OldEmployeeId: null,
        Password: '',
        ConfirmPassword: "",
        UserName: '',
        UserType: '',
      };
  }

  employeeUpdate() {

    if(this.updateEmployeeData){
      this.updateEmployeeData.Employee = this.viewModel;
      this._employeeSvc.postEmployeeProfile(this.updateEmployeeData).subscribe(response => {
        if (response) {
         // this.updateEmployeeData = response;
          console.log(response);
          this.activeModal.close('success');
          this._toasterSvc.success("Updated Successfully");

        }
      });
    }
    else{
      let mod = {
        Employee : this.viewModel
      };
      this._employeeSvc.postEmployeeProfile(mod).subscribe(response => {
        if (response) {
         // this.updateEmployeeData = response;
          console.log(response);
          this.activeModal.close('success');
          this._toasterSvc.success("Added Successfully");
  
        }
      });
    }
  }
  clear() {
    this.resetForm();
  }

  cancel(){
    this.activeModal.close(false);
  }

  onClose(){
    this.activeModal.close();
  }
  

}
